import React from "react";
import { LogIn, LogOut } from "lucide-react";
import { googleLoginRedirect } from "@/lib/auth";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Compact login / account chip for the app header.
 */
export default function GoogleAuthButton({ compact = false, target = "/" }) {
  const { user, logout, loading } = useAuth();

  if (loading) return null;

  if (user) {
    const initial = (user.name || user.email || "?").charAt(0).toUpperCase();
    return (
      <div className="flex items-center gap-2" data-testid="auth-account-chip">
        {user.picture ? (
          <img
            src={user.picture}
            alt=""
            className="w-7 h-7 border border-[#2A2A35]"
            referrerPolicy="no-referrer"
          />
        ) : (
          <div className="w-7 h-7 bg-[#FF6B00]/15 border border-[#FF6B00]/40 flex items-center justify-center font-bold text-[#FF6B00] text-xs">
            {initial}
          </div>
        )}
        {!compact && (
          <div className="hidden md:block text-xs">
            <div className="font-bold text-[#F0EDE8] truncate max-w-[140px]">
              {user.name || user.email}
            </div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-[#555]">
              {user.plan === "free" ? "Free plan" : user.plan}
            </div>
          </div>
        )}
        <button
          type="button"
          onClick={logout}
          aria-label="Sign out"
          className="w-8 h-8 flex items-center justify-center border border-[#2A2A35] text-[#888] hover:text-[#E24B4A] hover:border-[#E24B4A]"
          data-testid="auth-logout-btn"
        >
          <LogOut className="w-3.5 h-3.5" />
        </button>
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => googleLoginRedirect(target)}
      className="btn-ghost flex items-center gap-1.5 sm:gap-2 text-xs px-2 sm:px-3"
      data-testid="auth-google-login-btn"
      aria-label="Sign in with Google"
    >
      <LogIn className="w-3.5 h-3.5 shrink-0" />
      <span className="hidden sm:inline">Continue with Google</span>
      <span className="hidden min-[480px]:inline sm:hidden">Sign in</span>
    </button>
  );
}
